import React from 'react';
import useOrganisation from 'state/organisation/hooks/useOrganisation';
import { PAYMENTS } from 'state/payment/type';
import { GTW_STATUS } from 'utils/constants';
import CURRENCY from 'utils/currency';
import STRING from 'utils/string';
import { cn } from 'lib/utils';

type KeyValueRowProps = {
  label: string;
  value?: string | number | null;
  className?: string;
};

const KeyValueRow = ({ label, value, className }: KeyValueRowProps) => (
  <div className={cn('pb-1', className)}>
    <span className="inline-block min-w-52 max-w-60 pr-1 text-sm font-normal leading-5 text-gray-blue-50">
      {label}
    </span>
    <span className="text-sm font-normal leading-5 text-gray-blue-70">
      {value ?? 'NA'}
    </span>
  </div>
);

interface props {
  info: PAYMENTS.IGatewayTransaction;
}
const GatewayPaymentDetails = ({
  info = {} as PAYMENTS.IGatewayTransaction,
}: props): JSX.Element => {
  const {
    organisation: { settings },
  } = useOrganisation();

  const treezTicketID = STRING.getTreezTicketIDFromReferenceNumber(
    info.reference_number
  );

  const rows = [
    { label: 'TreezPay ID', value: info.gateway_id },
    { label: 'Processor ID', value: info.processor_payment_id },
    { label: 'External ID (short)', value: treezTicketID || 'NA' },
    ...(info.status === GTW_STATUS.ERROR ||
    info.status === GTW_STATUS.DECLINED ||
    info.status === GTW_STATUS.CANCELED ||
    info.status === GTW_STATUS.TERMINAL_BUSY ||
    info.status === GTW_STATUS.TERMINAL_ERROR
      ? [{ label: 'Failed Reason', value: info.failed_reason }]
      : []),
    {
      label: 'Payment Adjusted By',
      value: info.last_adjustment_id
        ? `${info?.treez_employee_first_name || 'NA'} ${
            info.treez_employee_last_name || 'NA'
          }`
        : null,
      className: 'capitalize',
    },
    { label: 'Payment Adjustment Id', value: info.last_adjustment_id },
  ];

  return (
    <div className="mb-9">
      <h3 className="mb-2 text-xl font-semibold leading-7 text-gray-blue-80">
        Payment details
      </h3>
      <hr className="mt-0 mb-2 pb-1" />
      <div>
        {rows.map((row, index) => (
          <KeyValueRow
            key={index}
            label={row.label}
            value={row.value}
            className={row.className}
          />
        ))}
      </div>
    </div>
  );
};

export default GatewayPaymentDetails;
